import { jsx } from "react/jsx-runtime";
import { useLocation, Navigate } from "react-router-dom";
const RemoveTrailingSlash = () => {
  const location = useLocation();
  const regex = new RegExp("/.*/$");
  if (regex.exec(location.pathname)) {
    return /* @__PURE__ */ jsx(
      Navigate,
      {
        replace: true,
        to: {
          pathname: location.pathname.replace(/\/+$/, ""),
          search: location.search
        }
      }
    );
  }
  return null;
};
export {
  RemoveTrailingSlash
};
